export const EN = { locale: 'en-US', language: 'English', code: 'en' }

export const languages = {
  'en-US': EN,
}

export const languageList = Object.values(languages)
